module.exports = __webpack_public_path__ + "img/tech_image_7_1.e071b65a.jpg";